import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { SnackbarProvider } from 'src/providers/snackbar/provider';
import { router } from 'src/routes';

export const App = () => (
  <SnackbarProvider>
    <RouterProvider router={router} />
  </SnackbarProvider>
);
